import { useCreate } from 'storfox-api-hooks'

import * as API from '../constants/api'

export const useOrderingReset = () => {
  const { create, ...state } = useCreate(API.ORDERING_RESET)
  return { ...state, reset: create }
}
